<template>
  <div>
    <select @change="updateCustomData" class="form-control" v-model="selectedDetail">
      <option disabled selected value="-1">Выберите или добавьте preset</option>
      <option v-for="(detail, index) in details" :value="index">
        {{ alias.calculatedRate }}: {{ detail.calculatedRate }}
        {{ alias.ratePercent }}: {{ detail.ratePercent }}
        {{ alias.baseMargin }}: {{ detail.baseMargin }}
        {{ alias.deliveryPercent }}: {{ detail.deliveryPercent }}
        {{ alias.delivery }}: {{ detail.delivery }}
      </option>
    </select>
    <div class="text-right" v-if="this.$can('changeCalculationPresets')">
      <div class="btn-group">
        <LoadingButton
          title="Добавить текущие данные в preset"
          className="btn btn-outline-success btn-xs"
          :onClick="addToPreset"
          type="button"
          :loading="loading"
          :color="$constants.SUCCESS_COLOR"
        />
        <LoadingButton
          title="Отметить как избранный preset"
          className="btn btn-outline-info btn-xs"
          :onClick="markAsFavorite"
          :loading="loading"
          type="button"
          :color="$constants.PRIMARY_COLOR"
        />
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import LoadingButton from "@/components/buttons/LoadingButton";

export default {
  props: ['customData', 'update'],
  components: {
    LoadingButton,
  },
  data() {
    return {
      loading: false,
      selectedDetail: -1,
      details: [],
      alias: {
        calculatedRate: 'Курс',
        ratePercent: 'Коэфф',
        baseMargin: 'Наценка',
        deliveryPercent: 'Расходы',
        delivery: 'Доставка',
      },
    }
  },
  mounted() {
    this.setFavoriteDetails();
  },
  methods: {
    updateCustomData() {
      if (this.update) {
        this.update({...this.details[this.selectedDetail]});
      }
    },
    async addToPreset() {
      this.loading = true;
      const {data} = await api.post('/new/users/details', {
        action: 'newDetail',
        alias: 'margin_calculation_preset',
        newData: this.customData
      })
      if (data.success) {
        toastr['success'](data.message ?? 'Сохранено!');
        this.details.push(this.customData);
      } else {
        toastr['warning'](data.message ?? 'Ошибка!');
      }
      this.loading = false;
    },
    async markAsFavorite() {
      // console.log(this.selectedDetail);
      if (this.selectedDetail === -1) return;
      this.loading = true;
      this.details.forEach((d, i) => {
        d.is_favorite = false;
        if (i === +this.selectedDetail) {
          d.is_favorite = true;
        }
      })
      const {data} = await api.post('/new/users/details', {
        action: 'updateDetail',
        alias: 'margin_calculation_preset',
        newData: this.details,
      })
      if (data.success) {
        toastr['success'](data.message ?? 'Сохранено!');
      } else {
        toastr['warning'](data.message ?? 'Ошибка!');
      }
      this.loading = false;
    },
    setFavoriteDetails() {
      const detail = this.$UserDetails.find((d) => d.alias === 'margin_calculation_preset');
      this.details = detail && detail.details || [];
      const index = this.details.findIndex((d) => d.is_favorite);
      if (index !== -1) {
        this.selectedDetail = index;
        if (this.update) {
          setTimeout(() => {
            this.update({...this.details[index]});
          }, 300)
        }
      }
    }
  }
}

</script>
